var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Project as ProjectModel, ProjectIncludes } from '@/models/Project';
import PageHeader from '@/components/page-header/PageHeader';
import ErrorHandler from '@/support/ErrorHandler';
import { TabsColorEnum } from '@/config/theme';
import { RolesEnum } from '@/items/Roles';
let Project = class Project extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.$pageTitle = 'Project';
        this.activeTab = '';
        this.isEditingDescription = false;
        this.project = null;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    async initialize() {
        await this.fetchProject();
    }
    async updateDescription() {
        if (!this.project) {
            this.closeEditMode();
            return;
        }
        this.project
            .update(this.descriptionPayload)
            .then((project) => {
            if (this.project) {
                this.project.description = project.description;
            }
            this.closeEditMode();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    tabStyle(tab) {
        if (!tab) {
            return;
        }
        if (!tab.color) {
            return;
        }
        if (this.isActiveTab(tab)) {
            return {
                backgroundColor: tab.color,
            };
        }
        return {
            borderBottom: `4px solid ${tab.color}`,
        };
    }
    // #endregion
    // #region Class methods
    startEditMode() {
        this.isEditingDescription = true;
    }
    closeEditMode() {
        this.descriptionPayload.description = (this.project && this.project.description) || '';
        this.isEditingDescription = false;
    }
    // #endregion
    // #region Async methods
    async fetchProject() {
        // this.project = await new ProjectModel().include([ProjectIncludes.AUDIT, ProjectIncludes.CHAT, ProjectIncludes.USERS, ProjectIncludes.ROLES, ProjectIncludes.PARENT, ProjectIncludes.NOTES, ProjectIncludes.LEVEL, ProjectIncludes.PROJECT_CATEGORY, ProjectIncludes.SUBJECTS]).find(this.$route.params.id);
        this.project = await new ProjectModel().include([ProjectIncludes.AUDIT, ProjectIncludes.CHAT, ProjectIncludes.USERS, ProjectIncludes.ROLES, ProjectIncludes.PARENT, ProjectIncludes.NOTES, ProjectIncludes.LEVEL, ProjectIncludes.PROJECT_CATEGORY]).find(this.$route.params.id);
        await this.$nextTick();
        if (!this.project)
            return;
        const subjects = await this.project.include(ProjectIncludes.PARENT).fetchProjectSubjects();
        this.$set(this.project, 'subjects', subjects);
    }
    isActiveTab(tab) {
        return tab && tab.to && this.activeTab === tab.to;
    }
    onMouseOver(event, tab) {
        document.documentElement.style.setProperty('--hover-color', tab.color || 'transparent');
    }
    // #endregion
    // #region Getters & Setters
    get descriptionPayload() {
        return {
            description: (this.project && this.project.description) || '',
        };
    }
    get breadcrumbs() {
        const projectName = this.project && this.project.name ? this.project.name : '';
        const groupName = this.routeQuery.groupName || '';
        if (this.isGroup) {
            return [
                {
                    name: this.$tc('Groups'),
                    path: '/groups',
                },
                {
                    name: groupName ? groupName : this.$tc('Group'),
                    path: `/groups/${this.groupId}`,
                },
                {
                    name: this.$tc('Assigned projects'),
                    path: `/groups/${this.groupId}/projects`,
                },
                {
                    name: projectName,
                },
            ];
        }
        return [{ name: this.$tc('Goal set categories'), path: '/project-categories' }, { name: this.$tc('Goal set category'), path: `/project-categories/${this.project && this.project.project_category ? this.project.project_category.id : ''}` }, { name: projectName ? projectName.toString() : '' }];
    }
    get tabs() {
        let tabs = [
            {
                description: 'string',
                icon: 'home',
                is_visible: true,
                label: 'HOME',
                to: this.isGroup ? `/projects/${this.project ? this.project.id : ''}?isGroup=true&groupId=${this.groupId}&projectId=${this.queryProjectId}&userIds=${this.userIds}` : `/projects/${this.project ? this.project.id : ''}`,
            },
            {
                color: TabsColorEnum.LIGHT_BLUE,
                description: `${this.$tc('navigationCard.project.subjects')}`,
                icon: 'flag',
                is_visible: true,
                label: this.$tc('projects.tabs.subjects'),
                to: this.isGroup ? `/projects/${this.project ? this.project.id : ''}/subjects?isGroup=true&groupId=${this.groupId}&projectId=${this.queryProjectId}&userIds=${this.userIds}` : `/projects/${this.project ? this.project.id : ''}/subjects`,
            },
            {
                color: TabsColorEnum.LIGHT_GREEN,
                description: this.$tc('Add or read the evaluation of the goal set'),
                icon: 'speaker_notes',
                is_visible: true,
                label: this.$tc('Evaluation'),
                to: this.isGroup ? `/projects/${this.project ? this.project.id : ''}/notes?isGroup=true&groupId=${this.groupId}&projectId=${this.queryProjectId}&userIds=${this.userIds}` : `/projects/${this.project ? this.project.id : ''}/notes`,
            },
            {
                color: TabsColorEnum.ORANGE,
                description: `${this.$tc('Add or read the goal set plan')}`,
                icon: 'folder',
                is_visible: true,
                label: this.$tc('projects.tabs.project_plan'),
                to: this.isGroup ? `/projects/${this.project ? this.project.id : ''}/project-plan?isGroup=true&groupId=${this.groupId}&projectId=${this.queryProjectId}&userIds=${this.userIds}` : `/projects/${this.project ? this.project.id : ''}/project-plan`,
            },
            {
                color: TabsColorEnum.RED,
                description: `${this.$tc('Add or view files related to the goal set')}`,
                icon: 'perm_media',
                is_visible: true,
                label: this.$tc('Files'),
                to: this.isGroup ? `/projects/${this.project ? this.project.id : ''}/media?isGroup=true&groupId=${this.groupId}&projectId=${this.queryProjectId}&userIds=${this.userIds}` : `/projects/${this.project ? this.project.id : ''}/media`,
            },
            {
                color: TabsColorEnum.BLUE,
                description: `${this.$tc('navigationCard.project.media')}`,
                icon: 'receipt_long',
                is_visible: true,
                label: this.$tc('Documents'),
                to: this.isGroup ? `/projects/${this.project ? this.project.id : ''}/documents?isGroup=true&groupId=${this.groupId}&projectId=${this.queryProjectId}&userIds=${this.userIds}` : `/projects/${this.project ? this.project.id : ''}/documents`,
            },
            {
                color: TabsColorEnum.DARK_GREEN,
                description: `${this.$tc('navigationCard.group.studentOverview')}`,
                icon: 'area_chart',
                is_visible: this.isGroup && this.user.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.TRAINER, RolesEnum.TEACHER]),
                label: this.$tc('navigationCard.group.titles.studentOverview'),
                to: `/groups/${this.groupId}/student-overview?projectId=${this.queryProjectId}&userIds=${this.userIds}`,
            },
            {
                color: TabsColorEnum.ORANGE,
                description: `${this.$tc('navigationCard.group.curriculum')}`,
                icon: 'dynamic_feed',
                is_visible: this.isGroup && this.user.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN, RolesEnum.BOARD, RolesEnum.TEACHER, RolesEnum.TRAINER]),
                label: this.$tc('navigationCard.group.titles.curriculum'),
                to: `/groups/${this.groupId}/curriculum?projectId=${this.queryProjectId}&userIds=${this.userIds}`,
            }
        ];
        return tabs;
    }
    get user() {
        return this.$store.state.Auth;
    }
    get routeQuery() {
        return this.$route.query;
    }
    get isGroup() {
        return this.routeQuery && !!this.routeQuery.isGroup;
    }
    get groupId() {
        return this.routeQuery.groupId || '';
    }
    get queryProjectId() {
        return this.routeQuery.projectId || '';
    }
    get userIds() {
        return this.routeQuery.userIds || [];
    }
};
Project = __decorate([
    Component({
        components: {
            PageHeader,
        },
    })
], Project);
export default Project;
